import { VIDEO } from '../../brands/default/constants';

export const setVideoVisibility = (id, visible) => (dispatch) => {
  return dispatch({
    id,
    type: VIDEO.SET_VISIBILITY,
    visible,
  });
};

export const setVideoAutoPlayable = (partial) => (dispatch) => {
  return dispatch({
    partial,
    type: VIDEO.SET_AUTO_PLAYABLE,
  });
};

export const playVideo = (id) => (dispatch) => {
  return dispatch({
    id,
    type: VIDEO.PLAY,
  });
};

export const stopVideo = (id) => (dispatch) => {
  return dispatch({
    id,
    type: VIDEO.STOP,
  });
};
